/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  SolrDocument,
} from '../models/index';
import {
    SolrDocumentFromJSON,
    SolrDocumentToJSON,
} from '../models/index';

export interface OrganisationSuggestRequest {
    q: string;
}

export interface PersonSuggestRequest {
    q: string;
}

export interface ProjectSuggestRequest {
    q: string;
}

export interface PublisherSuggestRequest {
    q: string;
}

export interface WorkSuggestRequest {
    q: string;
}

/**
 * 
 */
export class SuggestApi extends runtime.BaseAPI {

    /**
     * Creates request options for organisationSuggest without sending the request
     */
    async organisationSuggestRequestOpts(requestParameters: OrganisationSuggestRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['q'] == null) {
            throw new runtime.RequiredError(
                'q',
                'Required parameter "q" was null or undefined when calling organisationSuggest().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/suggest/organisation`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async organisationSuggestRaw(requestParameters: OrganisationSuggestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SolrDocument>>> {
        const requestOptions = await this.organisationSuggestRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SolrDocumentFromJSON));
    }

    /**
     */
    async organisationSuggest(requestParameters: OrganisationSuggestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SolrDocument>> {
        const response = await this.organisationSuggestRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for personSuggest without sending the request
     */
    async personSuggestRequestOpts(requestParameters: PersonSuggestRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['q'] == null) {
            throw new runtime.RequiredError(
                'q',
                'Required parameter "q" was null or undefined when calling personSuggest().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/suggest/person`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async personSuggestRaw(requestParameters: PersonSuggestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SolrDocument>>> {
        const requestOptions = await this.personSuggestRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SolrDocumentFromJSON));
    }

    /**
     */
    async personSuggest(requestParameters: PersonSuggestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SolrDocument>> {
        const response = await this.personSuggestRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for projectSuggest without sending the request
     */
    async projectSuggestRequestOpts(requestParameters: ProjectSuggestRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['q'] == null) {
            throw new runtime.RequiredError(
                'q',
                'Required parameter "q" was null or undefined when calling projectSuggest().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/suggest/project`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async projectSuggestRaw(requestParameters: ProjectSuggestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SolrDocument>>> {
        const requestOptions = await this.projectSuggestRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SolrDocumentFromJSON));
    }

    /**
     */
    async projectSuggest(requestParameters: ProjectSuggestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SolrDocument>> {
        const response = await this.projectSuggestRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for publisherSuggest without sending the request
     */
    async publisherSuggestRequestOpts(requestParameters: PublisherSuggestRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['q'] == null) {
            throw new runtime.RequiredError(
                'q',
                'Required parameter "q" was null or undefined when calling publisherSuggest().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/suggest/publisher`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async publisherSuggestRaw(requestParameters: PublisherSuggestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SolrDocument>>> {
        const requestOptions = await this.publisherSuggestRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SolrDocumentFromJSON));
    }

    /**
     */
    async publisherSuggest(requestParameters: PublisherSuggestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SolrDocument>> {
        const response = await this.publisherSuggestRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for workSuggest without sending the request
     */
    async workSuggestRequestOpts(requestParameters: WorkSuggestRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['q'] == null) {
            throw new runtime.RequiredError(
                'q',
                'Required parameter "q" was null or undefined when calling workSuggest().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/suggest/work`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async workSuggestRaw(requestParameters: WorkSuggestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SolrDocument>>> {
        const requestOptions = await this.workSuggestRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SolrDocumentFromJSON));
    }

    /**
     */
    async workSuggest(requestParameters: WorkSuggestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SolrDocument>> {
        const response = await this.workSuggestRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
